<template>
  <b-card
    no-body
    class="border border-2 h-100"
  >
    <div class="flex justify-between items-start mb-2 px-1 pt-1">
      <div>
        <div class="font-bold text-[16px] text-black">
          Data Agent
        </div>
        <div class="text-[#A0A0A0] text-[12px]">
          Last created data agent
        </div>
      </div>
      <MonthFilter
        :month.sync="month"
      />
    </div>

    <div class="px-1">
      <b-table
        show-empty
        :items="tableData"
        :fields="tableFields"
        thead-tr-class="bg-[#f3f4f6]"
        class="mb-0 text-[14px] border border-[#e5e7eb] rounded-lg overflow-hidden"
      >
        <template #empty>
          <div class="text-center py-4 text-[#828282]">
            Tidak Ada Data
          </div>
        </template>
        <template #cell(partner_name)="data">
          <span class="text-black font-medium">{{ data.value }}</span>
        </template>
        <template #cell(agent_name)="data">
          <span class="text-black font-medium">{{ data.value }}</span>
        </template>
        <template #cell(agent_phone)="data">
          <span class="text-[#828282]">{{ data.value }}</span>
        </template>
        <template #cell(status)="data">
          <span
            v-if="data.item.is_active"
            class="bg-[#DCFCE7] text-[#22C55E] text-[10px] px-2 py-0.5 rounded font-medium"
          >Aktif</span>
          <span
            v-else
            class="bg-[#FEE2E2] text-[#EF4444] text-[10px] px-2 py-0.5 rounded font-medium"
          >Tidak Aktif</span>
        </template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import moment from 'moment'
import { START_DATE_OF_MONTH, END_DATE_OF_MONTH } from '@/libs/filterDate'
import MonthFilter from './MonthFilter.vue'
import { apiDataAgents } from '../services/api.komchat.service'
import { fieldsDataAgent } from '../config'

export default {
  name: 'DataAgentCard',
  components: {
    MonthFilter,
  },
  data() {
    return {
      moment,
      month: moment(),
      tableFields: fieldsDataAgent,
      tableData: [],
    }
  },
  watch: {
    month() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const startDate = START_DATE_OF_MONTH(this.month)
      const endDate = END_DATE_OF_MONTH(this.month)

      try {
        const res = await apiDataAgents({ startDate, endDate })
        if (res && res.data && res.data.data) {
          this.tableData = res.data.data.map(item => ({
            partner_name: item.partner_name,
            agent_name: item.agent_name,
            agent_phone: item.agent_phone,
            is_active: item.is_active,
          }))
        } else {
          this.tableData = []
        }
      } catch (err) {
        console.error('Failed to fetch data agents', err)
      }
    },
  },
}
</script>

<style scoped>
/* To make the table wrapper rounded we need this if b-table doesn't clip cleanly */
::v-deep .table {
  margin-bottom: 0;
}
::v-deep .table th {
  border-top: none;
}
</style>
